import { render, staticRenderFns } from "./pyb-home.vue?vue&type=template&id=b6de36e8&scoped=true&"
import script from "./pyb-home.vue?vue&type=script&lang=js&"
export * from "./pyb-home.vue?vue&type=script&lang=js&"
import style0 from "./pyb-home.vue?vue&type=style&index=0&id=b6de36e8&lang=scss&scoped=true&"
import style1 from "./pyb-home.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6de36e8",
  null
  
)

export default component.exports